(function () {
    'use strict';
    var controllerId = 'cndPartecipConvalida';
    angular.module('app').controller(controllerId, ['common', '$scope', '$uibModalInstance', '_', 'datacontext', 'sectionMenu', 'partecipazione', 'tRuoloCode', 'pSedi', 'isSuper', fn_cndPartecipConvalida]);

    function fn_cndPartecipConvalida(common, $scope, $uibModalInstance, _, datacontext, sectionMenu, partecipazione, tRuoloCode, pSedi, isSuper) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');

        $scope.partecipazione = jQuery.extend({}, partecipazione);
        $scope.tRuoloCode = tRuoloCode;
        $scope.isSuper = isSuper;
        
        $scope.days = 0;
        //Ammissibilit� parziale per Misura 2-B
        $scope.entities = [];
        $scope.pCatalogoCorsiAmmessi = [];
        $scope.pCorsiAmmessi = [];
        $scope.pSedi = pSedi;
        $scope.bCatalogoCorsi = false;

        if (partecipazione && partecipazione.Id > 0) {

            switch ($scope.tRuoloCode) {
                case '2A':
                    getCorsi(partecipazione.Id);
                    break;
                case '2B':
                    getPCatalogoCorsi(partecipazione.Id);
                    break;
                case '4A':
                    getPCatalogoCorsi(partecipazione.Id);
                    break;
            }

        }

        function getCorsi(partecipazioneId) {
            $scope.entities = [];
            var iStato = 3; //Trasmessi
            return datacontext.pCorso_getAll(0, 0, '', $scope.tMisuraCode, partecipazioneId, 0, iStato, '').then(function (data) {
                console.info('getCorsi()', data);
                return $scope.entities = data;
            });
        }

        function getPCatalogoCorsi(partecipazioneId) {
            $scope.entities = [];
            return datacontext.pCatalogoCorso_getAll(0, 0, '', $scope.tMisuraCode, partecipazioneId, 0, 0, '').then(function (data) {
                console.info('getPCatalogoCorsi()', data);
                return $scope.entities = data;
            });
        }

        //valore di default se ancora � da convalidare di default nella modale imposto "ammissibile"
        if ($scope.partecipazione.iConvalida == 0)
            $scope.partecipazione.iConvalida = 3;

        $scope.ok = function (isValid) {
            if (isValid) {

                var result = [];
                $scope.pCatalogoCorsiAmmessi = [];
                $scope.pCorsiAmmessi = [];

                switch ($scope.partecipazione.iConvalida) {
                    case 3: //Ammissibilit� totale
                        if ($scope.tMisuraCode == '2A') {
                            $scope.pCorsiAmmessi = $scope.entities;
                        }
                        else if ($scope.tMisuraCode == '2B' || $scope.tMisuraCode == '4A') {
                            $scope.pCatalogoCorsiAmmessi = $scope.entities;
                        }
                        break;
                    case 4: //Ammissibilit� parziale
                        $("input:checkbox[name=listId]:checked").each(function () {

                            var id = $(this).val();
                            var entity = _.find($scope.entities, function (item) {
                                return item.Id == id;
                            });
                            //console.info('entity: ', entity);
                            if ($scope.tMisuraCode == '2A') {
                                $scope.pCorsiAmmessi.push(entity);
                            }
                            else if ($scope.tMisuraCode == '2B' || $scope.tMisuraCode == '4A') {
                                $scope.pCatalogoCorsiAmmessi.push(entity);
                            }

                        });
                        break;
                }

                result = updateItem($scope.partecipazione, $scope.pCatalogoCorsiAmmessi, $scope.pCorsiAmmessi, $scope.pSedi);
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.change_iConvalida = function () {
            $scope.partecipazione.ConvalidaNote = '';
            $scope.bCatalogoCorsi = false;

            if ($scope.partecipazione.iConvalida == 4) {
                $scope.bCatalogoCorsi = true;
            }

            if ($scope.partecipazione.iConvalida == 2) {
                switch ($scope.tMisuraCode) {
                    case '2A':
                        $scope.partecipazione.Asse1_2A_ImportoAmmesso = 0;
                        $scope.partecipazione.Asse1_2A_Qta = 0;
                        $scope.partecipazione.Asse1B_2A_ImportoAmmesso = 0;
                        $scope.partecipazione.Asse1B_2A_Qta = 0;
                        break;
                    case '2C':
                        $scope.partecipazione.Asse1_2C_ImportoAmmesso = 0;
                        $scope.partecipazione.Asse1_2C_Qta = 0;
                        $scope.partecipazione.Asse1B_2C_ImportoAmmesso = 0;
                        $scope.partecipazione.Asse1B_2C_Qta = 0;
                        break;
                    case '5':
                        $scope.partecipazione.Asse1_5_ImportoAmmesso = 0;
                        $scope.partecipazione.Asse1_5_Qta = 0;
                        $scope.partecipazione.Asse1B_5_ImportoAmmesso = 0;
                        $scope.partecipazione.Asse1B_5_Qta = 0;
                        break;
                }
                
            }

        };

        $scope.change_entity = function (item, bSingleEvent) {            
            //item.bShow = $("input:checkbox[id=opt_" + item.Id + "]:checked").val();
            if ($scope.tMisuraCode == '2B') {
                item.bShow = $("#opt_" + item.Id + "").is(":checked");

                if (!item.bShow) {
                    item.NumClasseAmmesse = 0;
                    item.NumAllieviAmmessi = 0;

                    if (bSingleEvent) {
                        if ($('#allId').is(":checked")) {
                            $('#allId').removeAttr('checked');
                            $('#allId').val('false');
                        }
                    }
                }
                else {
                    item.NumClasseAmmesse = item.NumClasse;
                    item.NumAllieviAmmessi = item.AllieviMax;
                }
            }
            
        };

        $scope.checkAll = function () {
            $('#allId').val('true');

            $scope.entities.forEach(function (e) {
                if ($scope.tMisuraCode == '2B') {
                    $scope.change_entity(e, false);
                }                
            });
        };

        function updateItem(partecipazione, pCatalogoCorsiAmmessi, pCorsiAmmessi, pSedi) {
            return datacontext.partecipazione_setConvalida(partecipazione, pCatalogoCorsiAmmessi, pCorsiAmmessi, pSedi).then(function (data) {
                return data;
            });
        }

    }
})();